/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel
     */
    isVisable?: string;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'isVisable': !exists(json, 'isVisable') ? undefined : json['isVisable'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'isVisable': value.isVisable,
    };
}

